module.exports = __webpack_public_path__ + "img/5-1.78e1108e.png";